<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-expansion-panels class="pt-2 pb-5">
				<v-expansion-panel>
					<v-expansion-panel-header disable-icon-rotate>
						<template #default="{ open }">
							<v-row no-gutters class="text-center">
								<v-col cols="12" class="text--secondary">
									<v-fade-transition leave-absolute>
										<span v-if="open" key="0">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
										<span v-else key="1">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
									</v-fade-transition>
								</v-col>
							</v-row>
						</template>
						<template #actions>
							<v-icon color="primary"></v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row justify="center" dense>
							<v-col cols="12" class="py-0">
								<v-alert type="info" class="mb-1">
									لا يمكن عمل التصفية على الدول أو المناطق, التصفية تكون على المدن فقط
								</v-alert>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete
									v-model="filters.countryID"
									outlined
									hide-details="auto"
									label="الدولة"
									:items="countries"
									item-text="name"
									item-value="countryID"
									disabled
								></v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete
									v-model="filters.regionID"
									outlined
									hide-details="auto"
									label="المنطقة"
									:items="regions"
									item-text="name"
									item-value="regionID"
									clearable
								></v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete
									v-model="filters.cityID"
									:items="cities"
									hide-details
									outlined
									item-value="cityID"
									item-text="name"
									label="المدينة"
									clearable
								></v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="filters.stateID"
									hide-details
									outlined
									label="الحالة"
									:items="states"
									item-text="text"
									item-value="value"
									clearable
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete
									v-model="filters.userID"
									:items="users"
									hide-details
									outlined
									item-text="fullName"
									item-value="id"
									label="صاحب الطلب"
									clearable
								>
									<template #item="{ item }">
										<!-- <v-list-item-avatar>
											<img :src="item.avatar" />
										</v-list-item-avatar>-->
										<v-list-item-content>
											<v-list-item-title>{{ item.fullName }}</v-list-item-title>
											<v-list-item-subtitle>{{ item.displayName }}</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-autocomplete>
							</v-col>
							<!-- <v-col cols="12" md="4">
								<v-menu
									v-model="menu1"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="filters.startDate"
											outlined
											hide-details="auto"
											label="بداية تاريخ النشر"
											readonly
											clearable
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="filters.startDate" landscape></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu
									v-model="menu2"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="filters.endDate"
											outlined
											hide-details="auto"
											label="نهاية تاريخ النشر"
											readonly
											clearable
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="filters.endDate" landscape></v-date-picker>
								</v-menu>
							</v-col>-->

							<v-col cols="12" md="4">
								<v-select
									v-model="filters.specialtiesID"
									hide-details
									outlined
									label="التخصص"
									:items="specialites"
									item-text="name"
									item-value="specialtiesID"
									clearable
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="filters.itemsPerPage"
									hide-details
									outlined
									label="عدد الطلبات في الصفحة"
									:items="itemsPerPage"
								></v-select>
							</v-col>
							<v-col cols="12" md="8">
								<v-select
									v-model="filters.order"
									outlined
									label="الترتيب"
									:items="orders"
									item-text="text"
									item-value="value"
									hide-details
								></v-select>
							</v-col>
							<v-col cols="12" class="text-center">
								<v-btn color="success" @click="applyFilter">تصفية</v-btn>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<v-data-table
				id="content"
				class="elevation-1"
				:headers="headers"
				:items="records"
				hide-default-footer
				:loading="loading"
				:items-per-page="-1"
				show-expand
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">جدول طلبات النقل ببديل</v-toolbar-title>
						<v-divider insert vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn class="primary" to="/dashboard/replacement/add">طلب نقل جديد</v-btn>
					</v-toolbar>
				</template>

				<template #expanded-item="{ item }">
					<td :colspan="headers.length + 1" class="pa-3 grey lighten-5">
						<v-data-table
							class="elevation-1"
							:headers="scheduledHeaders"
							:items="item.schedulePublish"
							hide-default-footer
							:items-per-page="-1"
						>
							<template #top>
								<v-toolbar flat>
									<v-toolbar-title class="px-4 text-body-1">المجدولة</v-toolbar-title>
									<v-divider insert vertical></v-divider>
								</v-toolbar>
							</template>

							<template #[`item.actionDate`]="{ item: scheduled }">
								<div dir="ltr" class="text-end">
									{{ scheduled.actionDate }}
								</div>
							</template>
							
							<template #[`item.created_at`]="{ item: scheduled }">
								<div dir="ltr" class="text-end">
									{{ scheduled.created_at.substr(0, 19).replace("T", " ") }}
								</div>
							</template>

							<template #[`item.actions`]="{ item: scheduled }">
								<v-tooltip bottom>
									<template #activator="{ on }">
										<v-btn icon :loading="loading" v-on="on" @click="deleteScheduled(scheduled)">
											<v-icon>mdi-trash-can</v-icon>
										</v-btn>
									</template>
									<span>حذف الجدولة</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</td>
				</template>

				<template #[`item.actions`]="{ item }">
					<v-tooltip v-if="item.privileges.view" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="openRecord(item.id)">
								<v-icon>mdi-open-in-new</v-icon>
							</v-btn>
						</template>

						<span>عرض</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.replacementOffer" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="viewOffers(item.id)">
								<v-icon>mdi-format-list-numbered-rtl</v-icon>
							</v-btn>
						</template>

						<span>معاينة العروض</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.close" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="close(item.id)">
								<v-icon>mdi-lock</v-icon>
							</v-btn>
						</template>

						<span>ايقاف استلام العروض</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.save" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="save(item.id)">
								<v-icon>mdi-content-save</v-icon>
							</v-btn>
						</template>

						<span>حفظ</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.publish" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="publishItem(item.id)"
							>
								<v-icon>mdi-calendar-plus</v-icon>
							</v-btn>
						</template>

						<span>نشر</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.republish" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="republishItem(item.id)"
							>
								<v-icon>mdi-calendar-refresh</v-icon>
							</v-btn>
						</template>

						<span>إعادة النشر</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.edit" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="editRecord(item.id)">
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</template>

						<span>تحرير</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.delete" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="confirmDeleteRecord(item.id)"
							>
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</template>

						<span>حذف</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.uTransfer" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="uploadReceipt(item.id)"
							>
								<v-icon>mdi-file-upload</v-icon>
							</v-btn>
						</template>

						<span>رفع الوصل</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.oTransfer" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="showReceipt(item.id)"
							>
								<v-icon>mdi-file-eye</v-icon>
							</v-btn>
						</template>

						<span>معاينة الوصل</span>
					</v-tooltip>
				</template>
			</v-data-table>

			<v-pagination v-model="page" :length="pageCount" class="pt-3"></v-pagination>
		</v-container>

		<v-dialog v-model="uploadReceiptDialog" transition="dialog-transition" max-width="500">
			<v-card>
				<v-card-text class="pa-4">
					<v-form v-model="valid">
						<v-row dense>
							<v-col cols="12" class="text-center text-h5 pb-4">الدفع</v-col>
							<v-col cols="12">
								<v-skeleton-loader v-if="!terms" type="paragraph@2"></v-skeleton-loader>
								<pre v-else>{{ terms }}</pre>
							</v-col>
							<v-col v-if="terms" cols="12">
								<v-file-input
									v-model="paymentAttachment"
									accept="image/*"
									append-icon="mdi-camera"
									prepend-icon
									label="صورة الايصال"
									outlined
									hide-details="auto"
									:rules="[rules.optionalImage]"
								></v-file-input>
							</v-col>
							<v-col cols="12" class="pa-2 text-center">
								<v-btn
									color="primary"
									class="mx-2"
									:loading="loading"
									:disabled="!paymentAttachment || !terms"
									@click="uploadPaymentAttachment"
								>
									حفظ
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="viewReceiptDialog" transition="dialog-transition">
			<v-card>
				<v-card-title primary-title>
					{{ receiptInfo }}
				</v-card-title>
				<v-card-text>
					<v-img contain :src="receipt"></v-img>
					<v-row no-gutters>
						<v-col class="text-center">
							<v-btn color="primary" :href="receipt" target="_blank">
								تحميل الوصل
								<v-icon right>mdi-download</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="publishDialog" width="550">
			<v-form v-if="publishDialog">
				<v-row justify="center" no-gutters>
					<v-col cols="12">
						<v-card class="text-center pa-4">
							<v-card-title>خيارات النشر</v-card-title>
							<v-row justify="center" class="mx-8" no-gutters>
								<v-col cols="6" md="6" class="pa-2">
									<v-menu
										v-model="menu1"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="publishInfo.date"
												outlined
												hide-details="auto"
												label="تاريخ النشر"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker v-model="publishInfo.date" @input="menu1 = false"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6" md="6" class="pa-2">
									<v-menu
										v-model="menu4"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="publishInfo.time"
												outlined
												hide-details="auto"
												label="وقت النشر"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker v-model="publishInfo.time" ampm-in-title :landscape="$vuetify.breakpoint.smAndUp"></v-time-picker>
									</v-menu>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="6" class="text-left">
									<v-btn color="primary" :loading="actionLoading" @click="publish()">نشر الآن</v-btn>
								</v-col>
								<v-col cols="6" class="text-right">
									<v-btn
										color="primary"
										:disabled="!publishInfo.date || !publishInfo.time"
										:loading="actionLoading"
										@click="scheduledPublish()"
									>
										النشر لاحقاً
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
			</v-form>
		</v-dialog>

		<v-dialog v-model="republishDialog" width="550">
			<v-form v-if="republishDialog">
				<v-row justify="center" no-gutters>
					<v-col cols="12">
						<v-card class="text-center pa-4">
							<v-card-title>خيارات إعادة النشر</v-card-title>
							<v-row justify="center" class="mx-8" no-gutters>
								<v-col cols="6" md="6" class="pa-2">
									<v-menu
										v-model="menu3"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="publishInfo.date"
												outlined
												hide-details="auto"
												label="تاريخ إعادة النشر"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker v-model="publishInfo.date" @input="menu3 = false"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6" md="6" class="pa-2">
									<v-menu
										v-model="menu4"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="publishInfo.time"
												outlined
												hide-details="auto"
												label="وقت إعادة النشر"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker v-model="publishInfo.time" ampm-in-title :landscape="$vuetify.breakpoint.smAndUp"></v-time-picker>
									</v-menu>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="6" class="text-left">
									<v-btn color="primary" :loading="actionLoading" @click="republish()">إعادة النشر الآن</v-btn>
								</v-col>
								<v-col cols="6" class="text-right">
									<v-btn
										color="primary"
										:disabled="!publishInfo.date || !publishInfo.time"
										:loading="actionLoading"
										@click="scheduledRepublish()"
									>
										إعادة النشر لاحقاً
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
			</v-form>
		</v-dialog>

		<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";

export default {
	components:{
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'النقل ببديل', exact: true, to: { name: "dashboard-replacement" } },
				{ text: 'إدارة', disabled: true }
			],
			headers: [
				{
					text: "رقم الطلب",
					value: "replacementID"
				},
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "من منطقة",
					value: "fromRegion"
				},
				{
					text: "إلى منطقة",
					value: "toRegion"
				},
				{
					text: "الحالة",
					value: "state"
				},
				{
					text: "تاريخ النشر",
					value: "publishedWrite"
				},
				{
					text: "عدد العروض",
					value: "numberOfOffer"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				},
				{
					text: "عدد النشر المجدول",
					value: "schedulePublishCount"
				},
				{
					text: "العمليات",
					value: "actions"
				}
			],
			records: [],
			pageCount: 1,
			page: 1,
			specialites: [],
			filters: {
				stateID: null,
				specialtiesID: null,
				userID: null,
				startDate: null,
				endDate: null,
				itemsPerPage: null,
				cityID: null,
				countryID: null,
				regionID: null,
				order: 'newFirst'
			},
			orders: [
				{ text: "الأحدث اولاً", value: "newFirst" },
				{ text: "الاقدم اولاً", value: "oldFirst" }
			],
			storedFilters: {},
			itemsPerPage: [10, 20, 30, 40, 50],
			menu1: false,
			menu2: false,
			menu3: false,
			menu4: false,
			users: [],
			states: [
				{ text: "غير مكتملة", value: "notCompleted" },
				{ text: "مسودة", value: "draft" },
				{ text: "محفوظة", value: "submited" },
				{ text: "منشورة", value: "published" },
				{ text: "مغلق", value: "closed" }
			],
			loading: true,
			actionLoading: false,
			uploadReceiptDialog: false,
			terms: null,
			paymentAttachment: null,
			recordID: null,
			valid: false,
			viewReceiptDialog: false,
			receipt: null,
			receiptInfo: "",
			countries: [],
			regions: [],
			cities: [],
			publishDialog: false,
			republishDialog: false,
			publishLater: true,
			publishInfo: {
				date: "",
				time: ""
			},
			scheduledHeaders: [
				// {
				// 	text: "المجدول",
				// 	value: "userName"
				// },
				{
					text: "وقت وتاريخ الجدولة",
					value: "actionDate"
				},
				{
					text: "وقت وتاريخ العملية",
					value: "created_at"
				},
				{
					text: "العمليات",
					value: "actions"
				}
			],
		};
	},
	computed: {
		dateRangeText() {
			return this.filters.dates.join(" ~ ");
		}
	},
	watch: {
		page(newVal) {
			this.getRecords(newVal);
			this.$vuetify.goTo('#content');
		},
		"filters.countryID"(newVal) {
			this.filters.regionID = null;
			this.regions = [];
			this.getRegions(newVal);
		},
		"filters.regionID"(newVal) {
			this.filters.cityID = null;
			this.cities = [];
			this.getCities(newVal);
		}
	},
	mounted() {
		this.getRecords(1);
		this.getTerms();
		this.getUsers();
		this.getSpecialties();
		
		// this.getCountries();
		this.countries = [
			{
				countryID: "sa",
				name: "المملكة العربية السعودية"
			}
		];
		this.filters.countryID = "sa";
	},
	methods: {
		getSpecialties() {
			client
				.get("/api/replacements/specialtiesList")
				.then(response => {
					this.specialites = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getUsers() {
			client
				.get("/api/users/list")
				.then(response => {
					this.users = Object.values(response.data.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getTerms() {
			client
				.get("/api/replacements/payment")
				.then(response => {
					this.terms = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		uploadPaymentAttachment() {
			this.loading = true;

			var data = new FormData();
			data.append("replacementID", this.recordID);
			data.append("attachment", this.paymentAttachment);
			clientNotifier
				.post("/api/replacements/settransfercopy", data)
				.then(() => {
					this.uploadReceiptDialog = false;
					this.recordID = null;
					this.paymentAttachment = null;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		refresh() {
			this.actionLoading = false;
			this.loading = true;
			this.records = [];
			this.getRecords(this.page);
		},
		getRecords(page) {
			client
				.post(
					"/api/replacements/allcp?page=" + page,
					this.storedFilters
				)
				.then(response => {
					this.pageCount = response.data.data.last_page;
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.id = record.replacementID;

							if (
								record.maleReplacement &&
								record.femaleReplacement
							) {
								record.gender = "بديل أو بديلة";
							} else if (record.maleReplacement) {
								record.gender = "بديل";
							} else if (record.femaleReplacement) {
								record.gender = "بديلة";
							}
							return record;
						}
					);
					this.loading = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		applyFilter() {
			this.storedFilters = { ...this.filters };
			this.records = [];
			this.loading = true;
			this.getRecords(1);
		},
		save(recordID) {
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/submit/" + recordID)
				.then(() => {
					this.refresh();
				});
		},
		publish() {
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/publish/" + this.recordID)
				.then(() => {
					this.refresh();
					this.publishDialog = false;
				});
		},
		scheduledPublish() {
			this.actionLoading = true;
			var data = {
				date: this.publishInfo.date + " " + this.publishInfo.time
			};
			clientNotifier
				.post("/api/replacements/publish/" + this.recordID, data)
				.then(() => {
					this.refresh();
					this.publishDialog = false;
				});
		},
		republish() {
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/publish/" + this.recordID)
				.then(() => {
					this.refresh();
					this.republishDialog = false;
				});
		},
		scheduledRepublish() {
			var data = {
				date: this.publishInfo.date + " " + this.publishInfo.time
			};
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/publish/" + this.recordID, data)
				.then(() => {
					this.refresh();
					this.republishDialog = false;
				});
		},
		async confirmDeleteRecord(recordID) {
			const confirmed = await this.$refs.confirm.open({ title: "تأكيد الحذف",  message: "هل تريد حقاً حذف هذا الطلب" });
			if (confirmed) { this.deleteRecord(recordID); }
		},
		deleteRecord(recordID) {
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/delete/" + recordID)
				.then(() => {
					this.refresh();
				});
		},
		close(recordID) {
			this.actionLoading = true;
			clientNotifier
				.post("/api/replacements/close/" + recordID)
				.then(() => {
					this.refresh();
				});
		},
		viewOffers(recordID) {
			var route = {
				name: "dashboard-replacement-offer",
				params: { offerID: recordID }
			};
			var url = this.$router.matcher.match(route).fullPath;
			var hash = "";
			if (window.location.hash) {
				hash = "#";
			}
			var win = window.open(hash + url, "_self");
			win.focus();
		},
		openRecord(recordID) {
			var route = { name: "replacement", params: { recordID } };
			var url = this.$router.matcher.match(route).fullPath;
			var hash = "";
			if (window.location.hash) {
				hash = "#";
			}
			var win = window.open(hash + url, "_blank");
			win.focus();
		},
		editRecord(recordID) {
			var route = {
				name: "dashboard-replacement-edit",
				params: { recordID: recordID }
			};
			var url = this.$router.matcher.match(route).fullPath;
			var hash = "";
			if (window.location.hash) {
				hash = "#";
			}
			var win = window.open(hash + url, "_blank");
			win.focus();
		},
		showReceipt(recordID) {
			this.actionLoading = true;
			clientNotifier
				.get("/api/replacements/gettransfercopy/" + recordID)
				.then(response => {
					console.log(response);
					this.receipt = addBaseURL(response.data.data);
					var record = this.records.filter(
						record => record.id == recordID
					)[0];
					this.receiptInfo = recordID + " - " + record.title;
					this.viewReceiptDialog = true;
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},
		uploadReceipt(recordID) {
			this.recordID = recordID;
			this.uploadReceiptDialog = true;
		},
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		publishItem(recordID) {
			this.recordID = recordID;
			this.publishDialog = true;
		},
		republishItem(recordID) {
			this.recordID = recordID;
			this.republishDialog = true;
		},
		async deleteScheduled(scheduled) {
			const confirmed = await this.$refs.confirm.open({
				title: 'تأكيد الحذف',
				message: 'هل تريد حقاً حذف هذا العرض؟',
			})
			if (!confirmed) {
				return
			}
			
			this.loading = true
			clientNotifier
				.delete("/api/schedule/replacements/delete/" + scheduled.id)
				.then(() => {
					this.getRecords(this.page)
				})
				.catch((e) => {
					console.log(e)
					this.loading = false
				});
		}
	}
};
</script>